module.exports = __webpack_public_path__ + "static/img/3104-2.613aee79.jpg";